import { Injectable, signal, WritableSignal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class VideoPopup {
    videoURL: WritableSignal<string> = signal('');
}